// removed by extract-text-webpack-plugin
module.exports = {"moveIn":"index-moveIn-8Uqzb","btnGroup":"index-btnGroup-1L3Mw","inputButton":"index-inputButton-1QsoR"};


//////////////////
// WEBPACK FOOTER
// ./src/business-components/common-modal/index.less
// module id = 1039
// module chunks = 0 1